var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEthereum(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1920 1920",
    enableBackground: "new 0 0 1920 1920",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#8A92B2",
    points: "959.8,80.7 420.1,976.3 959.8,731  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#62688F",
    points: "959.8,731 420.1,976.3 959.8,1295.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#62688F",
    points: "1499.6,976.3 959.8,80.7 959.8,731  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#454A75",
    points: "959.8,1295.4 1499.6,976.3 959.8,731  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#8A92B2",
    points: "420.1,1078.7 959.8,1839.3 959.8,1397.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#62688F",
    points: "959.8,1397.6 959.8,1839.3 1499.9,1078.7  "
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEthereum);
export default __webpack_public_path__ + "static/media/Ethereum.11858923e2328b0c191f499183940ae8.svg";
export { ForwardRef as ReactComponent };